import { NgModule } from "@angular/core";
import { ClickOutsideDirective } from "./ClickOutsideDirective";
import { AutofocusDirective } from "./AutofocusDirective";
import { ContenteditableValueAccessor } from "./ContentEditable";
import { TranslateDirective } from "./TranslateDirective";
@NgModule({
  declarations: [
    ClickOutsideDirective,
    AutofocusDirective,
    ContenteditableValueAccessor,
    TranslateDirective,
  ],
  imports: [],

  exports: [
    ClickOutsideDirective,
    AutofocusDirective,
    TranslateDirective,
    ContenteditableValueAccessor,
  ],

  providers: [],
})
export class DirectiveModule {}
